export default {
  validateConfig: ['dealer'],
  bookUrl: ENV.bookUrl,
  carstockApi: ENV.carstockApi,
  formServiceApi: ENV.formServiceApi,
  formServiceId: ENV.formServiceId,
  vehiclesCatalogApi: ENV.vehiclesCatalogApi,
  creditCalcSrcScript: ENV.creditCalcSrcScript,
  creditCalcSrcCss: ENV.creditCalcSrcCss,
  tradeInDomain: ENV.tradeInDomain,
  headerContainerSelector: ENV.headerContainerSelector,
  termsLink: ENV.termsLink,

  // Фича флаги в формате ENV.flagName === 'on':
  featureFlagCreditCalc: ENV.featureFlagCreditCalc === 'on',
  featureFlagTradeIn: ENV.featureFlagTradeIn === 'on',
  featureFlagFilteringByStatus: ENV.featureFlagFilteringByStatus === 'on',
  groupFilterEnable: true,
};
